module.exports = __webpack_public_path__ + "static/media/coin.f7730477.mp3";